export const DEMO_USER = {
    id: '1',
    first_name: 'Jane',
    last_name: 'Doe',
    email: 'jane.doe@example.com',
    phone: '+1 415 555 0192',
    email_notifications: true,
    user_initials: 'JP'
};